// extracted by mini-css-extract-plugin
module.exports = {"salary-chart":"SalaryChartSpread_salary-chart__Qf9FD"};